<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1 style="margin-top:250px;">About the Book</h1>
<p>A product of two cultures and academic worlds—Indian and American—Dr. Satyam Sikha Moorty (S.S. Moorty) taught literature courses for thirty-one years at Southern Utah University, Cedar City, Utah, U.S.A. Award-winning essayist, poet, scholar, and editor, Dr. Moorty was a Fulbright Professor/Specialist in Moldova (thrice), Austria, Azerbaijan, and Yemen, and a Balkan Scholar in Bulgaria. He published his poetry in the U.S., India, England, South Africa, Canada, and Moldova. He has published two books: 1) “Distant Lands, Diverse Cultures” and 2) “Moldova: Vigorous Heritage and Variegated Traditions: Poems, Essays, Stories, and Speeches”. His work examines his inter-cultural observations and experiences.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?0d93ab38